import clsx from 'clsx';
import React from 'react';
import toast from 'react-hot-toast';
import ReactHtmlParser from 'react-html-parser';

import { trackBillingErrorCta, trackBillingErrorImpression } from '@tracking/billingError';
import { User } from '@utils/backend-api/currentUser';
import { BillingErrorLike, getCtaConfig } from '@utils/billingErrors';

const ERROR_TOAST_CLASSNAME =
  'font-suisse-intl-mono w-full sm:w-fit rounded-none bg-primary-magenta text-disclosure-sm sm:text-disclosure-lg py-8 px-64 text-white font-bold sm:font-normal max-w-full text-center lg:max-w-container-lg lg:mx-28 [&_a]:text-white [&_a]:underline hover:[&_a]:text-primary-pink [&_a]:transition-colors [&_a]:duration-150 [&_a]:ease-in-out';

const ERROR_TOAST_DURATION_MS = 5000;

interface BillingErrorToastOptions {
  showCta?: boolean;
  currentUser?: User;
}

export function billingErrorToast(error: BillingErrorLike, options: BillingErrorToastOptions = {}) {
  const ctaConfig = options.showCta === false ? null : getCtaConfig(error.cta_type);

  const parsedMessage = ReactHtmlParser(error.message);

  trackBillingErrorImpression(error, options.currentUser);

  if (!ctaConfig || !error.cta_link) {
    toast.error(parsedMessage);
    return;
  }

  toast.custom(
    (t) => (
      <div className={clsx(ERROR_TOAST_CLASSNAME, { 'opacity-0': !t.visible })}>
        <div>{parsedMessage}</div>
        <a
          href={error.cta_link}
          className="mt-4 inline-block"
          onClickCapture={() =>
            trackBillingErrorCta(error, error.cta_type, ctaConfig.label, options.currentUser)
          }
        >
          {ctaConfig.label}
        </a>
      </div>
    ),
    { duration: ERROR_TOAST_DURATION_MS }
  );
}
